<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Configurar precios
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <!-- formulario de precios -->
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background p-l-10 p-r-10">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Nombre ambiente</div>
                      <div class="child-right">
                        {{item.value.description}}
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Estado</div>
                      <div class="child-right">
                        <span class="badge badge-success" *ngIf="item.value.is_show">Activo</span>
                        <span class="badge badge-danger" *ngIf="!item.value.is_show">Inactivo</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-8 col-12 m-t-20">
                  <p class="form__group__title f-s-13"> <i class="fas fa-list-alt m-r-3"></i>Lista de Mesas</p>
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 table-sm">
                      <thead class="thead-default">
                        <tr>
                          <th class="position-relative text-center">N° Ident. mesa <span class="required"></span></th>
                          <th>Tipo Capacidad</th>
                          <th class="position-relative text-center">Capacidad max.</th>
                          <th class="text-center">Código Mesa</th>
                          <th>Observación</th>
                          <th>Estado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="detail_tables.length == 0">
                          <tr>
                            <td colspan="2"><span>No se encontraron registros</span></td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail_tables.length > 0">
                          <tr *ngFor="let item of detail_tables; let index_ = index">
                            <td>
                              <input type="text" id="number_table{{index_}}" numeric
                                class="form-control form-control-xs text-center" value="{{item.number_table}}"
                                (keyup)="changeNumberTable($event.target, index_)" onclick="click_input(this)">
                            </td>
                            <td>
                              <select class="form-control form-control-xs" id="tableTypeSelected{{index_}}"
                                (change)="changeTableTypeSelected($event.target, index_)">
                                <ng-container *ngFor="let type of tabletypes">
                                  <ng-container *ngIf="type.id == item.tabletype_id">
                                    <option [value]="type.id" selected>{{ type.name }}</option>
                                  </ng-container>
                                  <ng-container *ngIf="type.id != item.tabletype_id">
                                    <option [value]="type.id">{{ type.name }}</option> 
                                  </ng-container>                                  
                                </ng-container>                                
                              </select>
                            </td>
                            <td>
                              <input type="text" id="capacity{{index_}}" numeric
                                class="form-control form-control-xs text-center" value="{{item.capacity}}"
                                (keyup)="changeCapacity($event.target, index_)">
                            </td>
                            <td>
                              <input type="text" id="code_table{{index_}}"
                                class="form-control form-control-xs text-center" value="{{item.code_table}}"
                                (keyup)="changeCodeTable($event.target, index_)">
                            </td>

                            <td>
                              <input type="text" id="observation{{index_}}" class="form-control form-control-xs"
                                value="{{item.observation}}" (keyup)="changeObservation($event.target, index_)">
                            </td>
                            <td>
                              -
                            </td>

                            <td>
                              <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                (click)="removeTable(item.id, index_)"></i>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                  <a class="btn btn-info btn-sm f-s-12 text-white m-t-10" (click)="addTable()">Agregar Mesa
                    <i class="fas fa-arrow-up m-l-5"></i>
                  </a>
                </div>

              </div>
            </div>

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
